/**
 * System-landscape diagram - framework-agnostic types.
 *
 * Moved here from `@protoss/ui` so both the web diagram (React/xyflow) and the
 * server-side SVG renderer (`@protoss/doc`) share one source of truth for the
 * topology/selection shapes. The xyflow-coupled node types stay in `@protoss/ui`.
 */
function hasTextContent(value) {
    return typeof value === 'string' && value.trim().length > 0;
}
export function hasSystemLandscapeSelectionContent(selection) {
    return hasTextContent(selection.currentTool) || hasTextContent(selection.postPlan);
}
//# sourceMappingURL=types.js.map